// Error contract of GET /stream-with-markup — a non-2xx answer carries {code, message}.
// Codes beyond these map to 'UNKNOWN' (same fallback as the iOS ServerErrorCode enum).
export type StreamErrorCode =
  | 'CREDITS_EXHAUSTED'
  | 'SUBSCRIPTION_REQUIRED'
  | 'LANGUAGE_NOT_SUPPORTED'
  | 'CONTENT_UNVOICEABLE'
  | 'UNAUTHORIZED'
  | 'NETWORK'
  // Client-derived, not a server code: the stream ended cleanly but short (IOS-2076).
  | 'TRUNCATED'
  | 'UNKNOWN';

export class StreamError extends Error {
  constructor(
    readonly code: StreamErrorCode,
    message: string
  ) {
    super(message);
  }
}

const KNOWN_CODES: readonly StreamErrorCode[] = [
  'CREDITS_EXHAUSTED',
  'SUBSCRIPTION_REQUIRED',
  'LANGUAGE_NOT_SUPPORTED',
  'CONTENT_UNVOICEABLE',
];

export function streamErrorFromBody(status: number, body: string): StreamError {
  if (status === 401) {
    return new StreamError('UNAUTHORIZED', 'Unauthorized');
  }

  try {
    const parsed = JSON.parse(body) as { code?: string; message?: string };
    const code = KNOWN_CODES.find(known => known === parsed.code) ?? 'UNKNOWN';

    return new StreamError(code, parsed.message ?? `Stream request failed with ${status}`);
  } catch {
    return new StreamError('UNKNOWN', `Stream request failed with ${status}`);
  }
}
